import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FamilyHistoryItem, FamilyHistoryState } from "./index.types";

export const initialFamilyHistoryState: FamilyHistoryState = {
  familyHistorySuccess: null,
  familyHistoryData: [],
  familyHistoryIsLoading: false,
};

const name = "familyHistory";

export const familyHistorySlice = createSlice({
  name,
  initialState: initialFamilyHistoryState,
  reducers: {
    getFamilyHistory: (state) => {
      state.familyHistoryIsLoading = true;
    },
    getFamilyHistorySuccess: (state, action: PayloadAction<FamilyHistoryItem[]>) => {
      state.familyHistorySuccess = true;
      state.familyHistoryIsLoading = false;
      state.familyHistoryData = action.payload;
    },
    getFamilyHistoryFail: (state) => {
      state.familyHistorySuccess = false;
      state.familyHistoryData = [];
      state.familyHistoryIsLoading = false;
    },
    clearFamilyHistoryData: (state) => {
      state.familyHistorySuccess = null;
      state.familyHistoryData = [];
      state.familyHistoryIsLoading = false;
    },
  },
});

export const { getFamilyHistory, clearFamilyHistoryData } = familyHistorySlice.actions;

export default familyHistorySlice.reducer;

export const getFamilyHistoryList = (patientId: string | number) => ({
  payload: {
    apiName: name,
    method: "get",
    url: `/api/patients/${patientId}/familyhistory/familyhistory_icd/`,
  },
  type: "getFamilyHistory",
});
